import SuperTable from './SuperTable';
export default SuperTable;